var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31124 25.7567C10.5843 25.7282 14.5139 28.6048 17.6766 31.2439V11.1699C14.432 8.45011 10.8141 6.51835 6.37551 6.25422C5.79745 6.21983 5.31124 6.68781 5.31124 7.26689L5.31124 25.7567ZM30.6265 6.2546C26.1875 6.51848 22.5697 8.45021 19.3253 11.1698V31.2437C22.4883 28.6047 26.4177 25.7281 31.6907 25.7565V7.26728C31.6907 6.68821 31.2046 6.22024 30.6265 6.2546ZM1.18945 10.6859V28.2009C1.18945 28.6938 1.54464 29.1151 2.03052 29.1984L15.6157 31.5274C12.874 29.4602 9.41552 27.3835 5.31125 27.4056H4.48696C4.0336 27.4056 3.66268 27.0347 3.66268 26.5813V9.86959L2.34269 9.68367C1.73361 9.59788 1.18945 10.0708 1.18945 10.6859ZM34.6595 9.68342L33.3393 9.86912V26.5809C33.3393 27.0342 32.9684 27.4052 32.515 27.4052H31.6907C27.5865 27.383 24.128 29.4597 21.3862 31.5269L34.9715 29.1979C35.4573 29.1146 35.8125 28.6934 35.8125 28.2004L35.8125 10.6856C35.8125 10.0706 35.2685 9.59776 34.6595 9.68342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.b71e036fed8585785625b54d9bb46391.svg";
export { ForwardRef as ReactComponent };